// Ribbon and Revel · Custom Streamer builder.
// Vanilla JS, no deps. Bootstraps from window.__rrBuilder:
//   { variants: { '4ft':id, '6ft':id, '8ft':id, '10ft':id, '25ft':id },
//     addons:   { 'mounting-kit':id, 'gift-box':id, 'rush-make':id, 'rush-make-25ft':id, 'custom-palette-upcharge':id },
//     colors:   [ { handle, name, hex, category }, ... ],
//     stockedPalettes: [ ['cream','terra',...], ... ] }

(function () {
  'use strict';
  var cfg = window.__rrBuilder;
  if (!cfg) { console.error('[rr-builder] window.__rrBuilder not set'); return; }

  // ---------- constants ----------
  // Keep in sync with the live custom-streamer variants (dashboard /products →
  // "Bulk add 25 ft length" writes the same figures).
  var BASE_PRICE = { '4ft': 9800, '6ft': 14800, '8ft': 19200, '10ft': 23200, '25ft': 57500 };
  var ADDON_PRICE = { 'mounting-kit': 1200, 'gift-box': 1800, 'rush-make': 3500 };
  // Rush is priced per streamer and tiered by length: a 25 ft build jumps the
  // queue at $100 (its own hidden SKU, rr-addon-rush-make-25ft); 4–10 ft stay $35.
  var RUSH_PRICE_BY_LENGTH = { '25ft': 10000 };
  function addonPrice(a) {
    if (a === 'rush-make' && RUSH_PRICE_BY_LENGTH[state.length] != null) return RUSH_PRICE_BY_LENGTH[state.length];
    return ADDON_PRICE[a] || 0;
  }
  // Which hidden addon SKU a chosen addon maps to at the current length.
  function addonKeyForCart(a) {
    if (a === 'rush-make' && state.length === '25ft' && cfg.addons && cfg.addons['rush-make-25ft']) return 'rush-make-25ft';
    return a;
  }
  var CUSTOM_PALETTE_UPCHARGE = 1200;
  // Preview strip counts. 25 ft is really ~150 strands; the 800px canvas reads
  // as a solid wall past ~100, so the preview caps there.
  var DENSITY = { '4ft': 20, '6ft': 30, '8ft': 44, '10ft': 60, '25ft': 100 };
  var LENGTH_LABEL = { '4ft': "4'", '6ft': "6'", '8ft': "8'", '10ft': "10'", '25ft': "25'" };
  var ADDON_LABEL = { 'mounting-kit': 'Mounting kit', 'gift-box': 'Gift box', 'rush-make': 'Rush make' };
  var MATERIAL_PRICE = {
    'vinyl':    { '4ft': 0,    '6ft': 0,    '8ft': 0,    '10ft': 0,    '25ft': 0 },
    'premium':  { '4ft': 1500, '6ft': 2500, '8ft': 3300, '10ft': 4000, '25ft': 10000 },
    'heirloom': { '4ft': 3600, '6ft': 6000, '8ft': 7800, '10ft': 9500, '25ft': 22500 }
  };
  var MATERIAL_LABEL = { 'vinyl': 'Light-catching vinyl (included)', 'premium': 'Premium fabric blend', 'heirloom': 'Heirloom mix' };
  var SPINE_PRICE = {
    'cotton-twine': { '4ft': 0,    '6ft': 0,    '8ft': 0,    '10ft': 0,    '25ft': 0 },
    'jute-rope':    { '4ft': 500,  '6ft': 800,  '8ft': 1200, '10ft': 1600, '25ft': 4000 },
    'linen-cord':   { '4ft': 1000, '6ft': 1500, '8ft': 2200, '10ft': 3000, '25ft': 7500 }
  };
  var SPINE_LABEL = { 'cotton-twine': 'White cotton twine (included)', 'jute-rope': 'Natural jute rope', 'linen-cord': 'Raw linen cord' };
  var STORAGE_KEY = 'rr_builder_state_v1';
  var MIN_COLORS = 3;
  var MAX_COLORS = 6;

  // Per-color weighting presets. The customer picks one of three named
  // balances; the builder writes the underlying integer weights to a hidden
  // `_palette_weights` line-item property, positionally aligned to `_palette`.
  // The studio dashboard's custom-streamer synthesizer normalizes those
  // weights into yardage fractions when the order webhook fires.
  // Keep these definitions in sync with studio-dashboard/app/lib/custom-streamer.ts.
  var BALANCE_PRESETS = ['Equal', 'Spotlight', 'Accent'];
  var BALANCE_LABEL = {
    'Equal':     { copy: 'Even mix',  hint: 'Each color shares the same fabric.' },
    'Spotlight': { copy: 'Spotlight', hint: 'First color is the headliner — more fabric, the rest accent.' },
    'Accent':    { copy: 'Accent',    hint: 'Graded mix — earlier colors get more, later ones a hint.' }
  };
  // Layout (how colors are arranged along the streamer). Independent of Balance
  // (which controls yardage share). 'woven' = scattered throughout (default);
  // 'blocks' = each color clustered into a contiguous band, in palette order.
  var ARRANGEMENT_PRESETS = ['woven', 'blocks'];
  var ARRANGEMENT_LABEL = {
    'woven':  { copy: 'Woven mix',    hint: 'Every color threaded throughout — a blended, painterly look.' },
    'blocks': { copy: 'Color blocks', hint: 'Each color clustered together in turn for a striped, color-blocked look.' }
  };
  // Resolve a CSS background value for a Color entry — handles solid, iridescent,
  // and metallic kinds plus optional photo_url overrides. Used by the selected-
  // palette pill chips so customers see the shifting nature of the colors they
  // picked. The actual SVG streamer rendering still uses the primary hex per
  // strand; rendering true iridescent gradients along each strand is out of
  // scope for v1.
  function colorBackground(c) {
    if (!c) return '#cccccc';
    if (c.photoUrl) return 'url(' + c.photoUrl + ') center / cover';
    if ((c.kind === 'iridescent' || c.kind === 'metallic') && c.accentHexes) {
      return 'linear-gradient(45deg, ' + c.hex + ', ' + c.accentHexes + ', ' + c.hex + ')';
    }
    return c.hex || '#cccccc';
  }

  function computeBalanceWeights(preset, n) {
    if (n <= 0) return [];
    if (n === 1) return [1];
    if (preset === 'Spotlight') {
      var arr = [n];
      for (var i = 1; i < n; i++) arr.push(1);
      return arr;
    }
    if (preset === 'Accent') {
      var arr2 = [];
      for (var j = 0; j < n; j++) arr2.push(n - j);
      return arr2;
    }
    // Equal (default)
    var ones = [];
    for (var k = 0; k < n; k++) ones.push(1);
    return ones;
  }

  // ---------- addon id fallback ----------
  // Liquid's all_products resolves at most 20 handles per page and lags
  // 5–15 min behind newly published products, so some hidden addon SKUs can
  // reach the browser as 0. Fill those from the storefront's public
  // /products/<handle>.js (first variant id) before anyone adds to cart.
  var ADDON_HANDLES = {
    materials: { 'premium': 'rr-addon-premium-fabric-', 'heirloom': 'rr-addon-heirloom-' },
    spines:    { 'jute-rope': 'rr-addon-jute-spine-', 'linen-cord': 'rr-addon-linen-spine-' },
    addons:    { 'mounting-kit': 'rr-addon-mounting-kit', 'gift-box': 'rr-addon-gift-box', 'rush-make': 'rr-addon-rush-make', 'rush-make-25ft': 'rr-addon-rush-make-25ft', 'custom-palette-upcharge': 'rr-addon-custom-palette-upcharge' }
  };
  function fetchFirstVariantId(handle, assign) {
    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p && p.variants && p.variants[0]) assign(p.variants[0].id); })
      .catch(function () {});
  }
  function hydrateMissingAddonIds() {
    Object.keys(ADDON_HANDLES.materials).forEach(function (tier) {
      var map = (cfg.materials = cfg.materials || {})[tier] = (cfg.materials[tier] || {});
      Object.keys(BASE_PRICE).forEach(function (len) {
        if (!map[len]) fetchFirstVariantId(ADDON_HANDLES.materials[tier] + len, function (id) { map[len] = id; });
      });
    });
    Object.keys(ADDON_HANDLES.spines).forEach(function (tier) {
      var map = (cfg.spines = cfg.spines || {})[tier] = (cfg.spines[tier] || {});
      Object.keys(BASE_PRICE).forEach(function (len) {
        if (!map[len]) fetchFirstVariantId(ADDON_HANDLES.spines[tier] + len, function (id) { map[len] = id; });
      });
    });
    cfg.addons = cfg.addons || {};
    Object.keys(ADDON_HANDLES.addons).forEach(function (key) {
      if (!cfg.addons[key]) fetchFirstVariantId(ADDON_HANDLES.addons[key], function (id) { cfg.addons[key] = id; });
    });
  }

  // ---------- color lookup ----------
  var colorByHandle = {};
  cfg.colors.forEach(function (c) { colorByHandle[c.handle] = c; });

  // ---------- state ----------
  var defaultState = { palette: ['cream', 'terra', 'blush', 'sand'], length: '6ft', material: 'vinyl', spine: 'cotton-twine', addons: [], occasion: '', balance: 'Equal', arrangement: 'woven' };
  var state = loadFromURL() || loadState() || Object.assign({}, defaultState);

  // Deep-link: /pages/builder?palette=blush,rose,cream,sand&length=8ft (used by journal "Get this palette" CTAs)
  function loadFromURL() {
    var params = new URLSearchParams(window.location.search);
    var pp = params.get('palette');
    if (!pp) return null;
    var palette = pp.split(',').map(function (h) { return h.trim().toLowerCase(); }).filter(function (h) { return colorByHandle[h]; }).slice(0, MAX_COLORS);
    if (palette.length < MIN_COLORS) return null;
    var len = (params.get('length') || '6ft').toLowerCase();
    if (!BASE_PRICE[len]) len = '6ft';
    var occasion = params.get('occasion') || '';
    var mat = (params.get('material') || 'vinyl').toLowerCase();
    if (!MATERIAL_PRICE[mat]) mat = 'vinyl';
    var sp = (params.get('spine') || 'cotton-twine').toLowerCase();
    if (!SPINE_PRICE[sp]) sp = 'cotton-twine';
    var bal = params.get('balance') || 'Equal';
    if (BALANCE_PRESETS.indexOf(bal) === -1) bal = 'Equal';
    var arr = (params.get('arrangement') || 'woven').toLowerCase();
    if (ARRANGEMENT_PRESETS.indexOf(arr) === -1) arr = 'woven';
    return { palette: palette, length: len, material: mat, spine: sp, addons: [], occasion: occasion, balance: bal, arrangement: arr };
  }

  function loadState() {
    try {
      var s = JSON.parse(localStorage.getItem(STORAGE_KEY));
      if (!s || !s.palette || !s.length) return null;
      // sanitize: only known color handles
      s.palette = s.palette.filter(function (h) { return colorByHandle[h]; });
      if (!BASE_PRICE[s.length]) s.length = '6ft';
      s.addons = (s.addons || []).filter(function (a) { return ADDON_PRICE[a]; });
      if (!MATERIAL_PRICE[s.material]) s.material = 'vinyl';
      if (!SPINE_PRICE[s.spine]) s.spine = 'cotton-twine';
      if (!s.balance || BALANCE_PRESETS.indexOf(s.balance) === -1) s.balance = 'Equal';
      if (!s.arrangement || ARRANGEMENT_PRESETS.indexOf(s.arrangement) === -1) s.arrangement = 'woven';
      return s;
    } catch (e) { return null; }
  }
  function persist() {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {}
  }
  function setState(patch) {
    Object.assign(state, patch);
    persist();
    rerender();
  }

  // ---------- pricing ----------
  function isStockedPalette(palette) {
    if (!cfg.stockedPalettes) return false;
    var key = palette.slice().sort().join(',');
    return cfg.stockedPalettes.some(function (sp) { return sp.slice().sort().join(',') === key; });
  }
  function calculateTotal() {
    var total = BASE_PRICE[state.length] || 0;
    if (!isStockedPalette(state.palette) && state.palette.length >= MIN_COLORS) total += CUSTOM_PALETTE_UPCHARGE;
    state.addons.forEach(function (a) { total += addonPrice(a); });
    var matPrice = (MATERIAL_PRICE[state.material] || {})[state.length] || 0;
    total += matPrice;
    var spinePrice = (SPINE_PRICE[state.spine] || {})[state.length] || 0;
    total += spinePrice;
    return total;
  }
  function formatMoney(cents) {
    var d = (cents / 100);
    return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2));
  }

  // ---------- DOM refs ----------
  var root = document.querySelector('[data-rr-builder]');
  if (!root) return;
  var swatchGrid = root.querySelector('[data-rr-swatch-grid]');
  var selectedRow = root.querySelector('[data-rr-selected-palette]');
  var balanceRoot = root.querySelector('[data-rr-balance]');
  var arrangementRoot = root.querySelector('[data-rr-arrangement]');
  var lengthBtns = root.querySelectorAll('[data-rr-length]');
  var materialInputs = root.querySelectorAll('[data-rr-material]');
  var materialPriceEls = root.querySelectorAll('[data-rr-material-price]');
  var spineInputs = root.querySelectorAll('[data-rr-spine]');
  var spinePriceEls = root.querySelectorAll('[data-rr-spine-price]');
  var addonInputs = root.querySelectorAll('[data-rr-addon]');
  var occasionSelect = root.querySelector('[data-rr-occasion]');
  var notesEl = root.querySelector('[data-rr-notes]');
  var priceEl = root.querySelector('[data-rr-price]');
  var priceBreakdownEl = root.querySelector('[data-rr-price-breakdown]');
  var helperEl = root.querySelector('[data-rr-helper]');
  var addBtn = root.querySelector('[data-rr-add]');
  var previewSvg = document.getElementById('builder-preview-svg');

  // ---------- swatch picker ----------
  function renderSwatches() {
    swatchGrid.querySelectorAll('.builder-swatch').forEach(function (b) {
      var h = b.getAttribute('data-color-handle');
      var inPalette = state.palette.indexOf(h) !== -1;
      var atMax = state.palette.length >= MAX_COLORS;
      b.classList.toggle('is-active', inPalette);
      b.disabled = !inPalette && atMax;
      b.setAttribute('aria-pressed', inPalette ? 'true' : 'false');
    });
  }
  swatchGrid?.addEventListener('click', function (e) {
    var btn = e.target.closest('.builder-swatch');
    if (!btn) return;
    var h = btn.getAttribute('data-color-handle');
    if (!colorByHandle[h]) return;
    var i = state.palette.indexOf(h);
    if (i !== -1) {
      state.palette.splice(i, 1);
    } else {
      if (state.palette.length >= MAX_COLORS) return;
      state.palette.push(h);
    }
    setState({});
  });

  // ---------- selected palette: re-order + remove ----------
  function renderSelected() {
    selectedRow.innerHTML = '';
    state.palette.forEach(function (h, idx) {
      var c = colorByHandle[h];
      if (!c) return;
      var pill = document.createElement('div');
      pill.className = 'builder-pill';
      pill.setAttribute('draggable', 'true');
      pill.setAttribute('data-handle', h);
      pill.setAttribute('data-index', String(idx));
      pill.innerHTML =
        '<span class="builder-pill__dot" style="background:' + colorBackground(c) + '"></span>' +
        '<span class="builder-pill__name">' + escapeHtml(c.name) + '</span>' +
        '<button type="button" class="builder-pill__up" aria-label="Move ' + escapeHtml(c.name) + ' left" data-action="up">←</button>' +
        '<button type="button" class="builder-pill__down" aria-label="Move ' + escapeHtml(c.name) + ' right" data-action="down">→</button>' +
        '<button type="button" class="builder-pill__remove" aria-label="Remove ' + escapeHtml(c.name) + '" data-action="remove">×</button>';
      selectedRow.appendChild(pill);
    });
    if (state.palette.length === 0) {
      var ph = document.createElement('p');
      ph.className = 'builder-selected__empty';
      ph.textContent = 'Tap a color below to start your palette.';
      selectedRow.appendChild(ph);
    }
  }

  selectedRow?.addEventListener('click', function (e) {
    var btn = e.target.closest('button[data-action]');
    if (!btn) return;
    var pill = btn.closest('.builder-pill');
    var idx = parseInt(pill.getAttribute('data-index'), 10);
    var action = btn.getAttribute('data-action');
    if (action === 'remove') {
      state.palette.splice(idx, 1);
    } else if (action === 'up' && idx > 0) {
      var t = state.palette[idx - 1]; state.palette[idx - 1] = state.palette[idx]; state.palette[idx] = t;
    } else if (action === 'down' && idx < state.palette.length - 1) {
      var t2 = state.palette[idx + 1]; state.palette[idx + 1] = state.palette[idx]; state.palette[idx] = t2;
    }
    setState({});
  });

  // drag-to-reorder (desktop pointer)
  var dragSrcIdx = null;
  selectedRow?.addEventListener('dragstart', function (e) {
    var pill = e.target.closest('.builder-pill');
    if (!pill) return;
    dragSrcIdx = parseInt(pill.getAttribute('data-index'), 10);
    pill.classList.add('is-dragging');
    if (e.dataTransfer) { e.dataTransfer.effectAllowed = 'move'; e.dataTransfer.setData('text/plain', String(dragSrcIdx)); }
  });
  selectedRow?.addEventListener('dragover', function (e) {
    if (dragSrcIdx === null) return;
    e.preventDefault();
    if (e.dataTransfer) e.dataTransfer.dropEffect = 'move';
  });
  selectedRow?.addEventListener('drop', function (e) {
    e.preventDefault();
    if (dragSrcIdx === null) return;
    var pill = e.target.closest('.builder-pill');
    var dstIdx = pill ? parseInt(pill.getAttribute('data-index'), 10) : state.palette.length - 1;
    if (dragSrcIdx !== dstIdx) {
      var moved = state.palette.splice(dragSrcIdx, 1)[0];
      state.palette.splice(dstIdx, 0, moved);
      setState({});
    }
    dragSrcIdx = null;
    selectedRow.querySelectorAll('.is-dragging').forEach(function (el) { el.classList.remove('is-dragging'); });
  });
  selectedRow?.addEventListener('dragend', function () {
    dragSrcIdx = null;
    selectedRow.querySelectorAll('.is-dragging').forEach(function (el) { el.classList.remove('is-dragging'); });
  });

  // ---------- balance (per-color weighting) ----------
  function renderBalance() {
    if (!balanceRoot) return;
    // Two-color minimum: with a single color, weighting is meaningless.
    if (state.palette.length < 2) {
      balanceRoot.innerHTML = '';
      balanceRoot.hidden = true;
      return;
    }
    balanceRoot.hidden = false;
    var label = '<p class="builder-balance__label"><span aria-hidden="true">◆</span> Balance <small>Optional</small></p>';
    var hintCopy = (BALANCE_LABEL[state.balance] && BALANCE_LABEL[state.balance].hint) || '';
    var hint = '<p class="builder-balance__hint">' + escapeHtml(hintCopy) + '</p>';
    var chips = '<div class="builder-balance__chips" role="radiogroup" aria-label="Balance">';
    BALANCE_PRESETS.forEach(function (p) {
      var active = state.balance === p;
      var copy = (BALANCE_LABEL[p] && BALANCE_LABEL[p].copy) || p;
      chips +=
        '<button type="button" class="builder-balance__chip' + (active ? ' is-active' : '') + '" ' +
        'role="radio" aria-checked="' + (active ? 'true' : 'false') + '" ' +
        'data-rr-balance-preset="' + escapeHtml(p) + '">' + escapeHtml(copy) + '</button>';
    });
    chips += '</div>';
    balanceRoot.innerHTML = label + chips + hint;
  }
  if (balanceRoot) {
    balanceRoot.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rr-balance-preset]');
      if (!btn) return;
      var p = btn.getAttribute('data-rr-balance-preset');
      if (BALANCE_PRESETS.indexOf(p) === -1) return;
      setState({ balance: p });
    });
  }

  // ---------- layout / arrangement (woven mix vs color blocks) ----------
  function renderArrangement() {
    if (!arrangementRoot) return;
    // With a single color, arrangement is meaningless — hide like Balance.
    if (state.palette.length < 2) {
      arrangementRoot.innerHTML = '';
      arrangementRoot.hidden = true;
      return;
    }
    arrangementRoot.hidden = false;
    var label = '<p class="builder-balance__label"><span aria-hidden="true">◆</span> Layout <small>Optional</small></p>';
    var hintCopy = (ARRANGEMENT_LABEL[state.arrangement] && ARRANGEMENT_LABEL[state.arrangement].hint) || '';
    var hint = '<p class="builder-balance__hint">' + escapeHtml(hintCopy) + '</p>';
    var chips = '<div class="builder-balance__chips" role="radiogroup" aria-label="Layout">';
    ARRANGEMENT_PRESETS.forEach(function (p) {
      var active = state.arrangement === p;
      var copy = (ARRANGEMENT_LABEL[p] && ARRANGEMENT_LABEL[p].copy) || p;
      chips +=
        '<button type="button" class="builder-balance__chip' + (active ? ' is-active' : '') + '" ' +
        'role="radio" aria-checked="' + (active ? 'true' : 'false') + '" ' +
        'data-rr-arrangement-preset="' + escapeHtml(p) + '">' + escapeHtml(copy) + '</button>';
    });
    chips += '</div>';
    arrangementRoot.innerHTML = label + chips + hint;
  }
  if (arrangementRoot) {
    arrangementRoot.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rr-arrangement-preset]');
      if (!btn) return;
      var p = btn.getAttribute('data-rr-arrangement-preset');
      if (ARRANGEMENT_PRESETS.indexOf(p) === -1) return;
      setState({ arrangement: p });
    });
  }

  // ---------- length ----------
  function renderLength() {
    lengthBtns.forEach(function (b) {
      var v = b.getAttribute('data-rr-length');
      var on = v === state.length;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  lengthBtns.forEach(function (b) {
    b.addEventListener('click', function () { setState({ length: b.getAttribute('data-rr-length') }); });
  });

  // ---------- material ----------
  function renderMaterial() {
    materialInputs.forEach(function (inp) { inp.checked = inp.value === state.material; });
    // Update the displayed +$ price for the current length on each premium tier chip
    materialPriceEls.forEach(function (el) {
      var tier = el.getAttribute('data-rr-material-price');
      var cents = (MATERIAL_PRICE[tier] || {})[state.length] || 0;
      el.textContent = '+' + formatMoney(cents);
    });
  }
  materialInputs.forEach(function (inp) {
    inp.addEventListener('change', function () {
      if (inp.checked) setState({ material: inp.value });
    });
  });

  // ---------- spine ----------
  function renderSpine() {
    spineInputs.forEach(function (inp) { inp.checked = inp.value === state.spine; });
    spinePriceEls.forEach(function (el) {
      var tier = el.getAttribute('data-rr-spine-price');
      var cents = (SPINE_PRICE[tier] || {})[state.length] || 0;
      el.textContent = '+' + formatMoney(cents);
    });
  }
  spineInputs.forEach(function (inp) {
    inp.addEventListener('change', function () {
      if (inp.checked) setState({ spine: inp.value });
    });
  });

  // ---------- add-ons ----------
  function renderAddons() {
    addonInputs.forEach(function (inp) {
      inp.checked = state.addons.indexOf(inp.value) !== -1;
    });
    // Length-tiered addon prices (rush) — update the "+$" label to the current length.
    root.querySelectorAll('[data-rr-addon-price]').forEach(function (el) {
      var key = el.getAttribute('data-rr-addon-price');
      el.textContent = '+' + formatMoney(addonPrice(key));
    });
  }
  addonInputs.forEach(function (inp) {
    inp.addEventListener('change', function () {
      var v = inp.value;
      var i = state.addons.indexOf(v);
      if (inp.checked && i === -1) state.addons.push(v);
      else if (!inp.checked && i !== -1) state.addons.splice(i, 1);
      setState({});
    });
  });

  // ---------- occasion (optional) ----------
  occasionSelect?.addEventListener('change', function () { setState({ occasion: occasionSelect.value }); });

  // ---------- preview SVG (port of StreamerSVG from shell.jsx) ----------
  var SVG_NS = 'http://www.w3.org/2000/svg';
  function renderPreview() {
    if (!previewSvg) return;
    var palette = state.palette.length > 0 ? state.palette : ['cream', 'ink'];
    var density = state.palette.length >= MIN_COLORS ? DENSITY[state.length] : Math.min(12, DENSITY[state.length]);
    var width = 800, height = 500, cordY = height * 0.18;
    var seed = (palette.join('').length + state.length.length + 1) >>> 0;

    // simple LCG for deterministic strands
    var s = seed;
    function rand() { s = (s * 1664525 + 1013904223) >>> 0; return s / 0xffffffff; }

    // Color blocks: precompute cumulative band boundaries from the Balance
    // weights so each color's band width reflects its fabric share (Spotlight =
    // a big first band, etc.). null when arrangement is the default woven mix.
    var blockCum = null;
    if (state.arrangement === 'blocks') {
      var bw = computeBalanceWeights(state.balance, palette.length);
      var tot = bw.reduce(function (a, b) { return a + b; }, 0) || 1, acc = 0;
      blockCum = bw.map(function (w) { acc += w; return acc / tot; });
    }

    // build strips
    var strips = [];
    for (var i = 0; i < density; i++) {
      var x = (i + 0.5) / density * width + (rand() - 0.5) * (width / density * 0.4);
      // Always consume one RNG draw here so strip geometry is identical across
      // layouts — only the color assignment differs (woven = random, blocks =
      // by position into the weighted bands).
      var rci = rand();
      var ci;
      if (blockCum) {
        var f = (i + 0.5) / density, k = 0;
        while (k < blockCum.length - 1 && f > blockCum[k]) k++;
        ci = k;
      } else {
        ci = Math.floor(rci * palette.length);
      }
      var hex = (colorByHandle[palette[ci]] && colorByHandle[palette[ci]].hex) || '#cccccc';
      var len = height * (0.55 + rand() * 0.38);
      var sway = (rand() - 0.5) * 24;
      var w = 7 + rand() * 9;
      var taper = 0.55 + rand() * 0.3;
      var kindRoll = rand();
      var kind = kindRoll < 0.25 ? 'sheer' : (kindRoll < 0.5 ? 'ribbon' : 'fabric');
      var opa = kind === 'sheer' ? 0.42 : (kind === 'ribbon' ? 0.95 : 0.88);
      var tear = (rand() - 0.5) * 10;
      strips.push({ x: x, hex: hex, len: len, sway: sway, w: w, taper: taper, kind: kind, opa: opa, tear: tear, ci: ci });
    }

    // construct SVG markup as a string then assign
    var defs = ['<linearGradient id="rrb-bg" x1="0" y1="0" x2="0" y2="1">',
                '<stop offset="0" stop-color="#FBF8F2"/>',
                '<stop offset="1" stop-color="#ECE3D2"/>',
                '</linearGradient>',
                '<filter id="rrb-blur"><feGaussianBlur stdDeviation="0.7"/></filter>'].join('');
    palette.forEach(function (h, idx) {
      var colorObj = colorByHandle[h] || {};
      var c = colorObj.hex || '#cccccc';
      // Iridescent / metallic: cycle hex → accent stops → hex along the strand
      // width so each strand catches different parts of the shift. Photo-backed
      // colors fall back to the solid gradient since SVG <pattern> for per-strand
      // photo fills is more weight than v1 justifies.
      var accentList = (colorObj.kind === 'iridescent' || colorObj.kind === 'metallic')
        && colorObj.accentHexes
        ? colorObj.accentHexes.split(',').map(function (s) { return s.trim(); }).filter(Boolean)
        : [];
      if (accentList.length > 0) {
        // Build a multi-stop iridescent gradient. Pattern: hex → a1 → a2 → ... → hex.
        // Soft highlight stays at ~50% via a low-opacity white sliver.
        var stops = [c].concat(accentList).concat([c]);
        var stopMarkup = stops.map(function (col, si) {
          var offset = si / (stops.length - 1);
          return '<stop offset="' + offset.toFixed(3) + '" stop-color="' + col + '" stop-opacity="1"/>';
        }).join('');
        defs += '<linearGradient id="rrb-c-' + idx + '" x1="0" y1="0" x2="1" y2="0">' +
          stopMarkup +
          '</linearGradient>';
      } else {
        defs += '<linearGradient id="rrb-c-' + idx + '" x1="0" y1="0" x2="1" y2="0">' +
          '<stop offset="0" stop-color="' + c + '" stop-opacity="0.85"/>' +
          '<stop offset="0.45" stop-color="' + c + '" stop-opacity="1"/>' +
          '<stop offset="0.55" stop-color="#ffffff" stop-opacity="0.22"/>' +
          '<stop offset="0.7" stop-color="' + c + '" stop-opacity="1"/>' +
          '<stop offset="1" stop-color="' + c + '" stop-opacity="0.82"/>' +
          '</linearGradient>';
      }
    });

    var bgRect = '<rect width="' + width + '" height="' + height + '" fill="url(#rrb-bg)"/>' +
                 '<rect width="' + width + '" height="' + (height * 0.45) + '" fill="rgba(168,81,63,0.04)"/>' +
                 '<path d="M 4 ' + cordY + ' Q ' + (width / 2) + ' ' + (cordY - 8) + ' ' + (width - 4) + ' ' + (cordY + 2) + '" stroke="#8A3D2E" stroke-width="1.6" fill="none" opacity="0.6"/>';

    var sheers = '', solids = '', knots = '';
    strips.forEach(function (st, i) {
      var x = st.x, y0 = cordY + 2;
      if (st.kind === 'sheer') {
        var cx = x + st.sway * 0.8, cy = y0 + st.len * 0.5;
        var x2 = x + st.sway, y2 = y0 + st.len;
        var w = st.w * 1.3;
        var d = 'M ' + (x - w / 2) + ' ' + y0 + ' Q ' + (cx - w / 2) + ' ' + cy + ' ' + (x2 - w / 2 + st.tear) + ' ' + y2 +
                ' L ' + (x2 + w / 2 - st.tear) + ' ' + y2 + ' Q ' + (cx + w / 2) + ' ' + cy + ' ' + (x + w / 2) + ' ' + y0 + ' Z';
        sheers += '<path d="' + d + '" fill="' + st.hex + '" opacity="' + st.opa + '" filter="url(#rrb-blur)"/>';
      } else {
        var cx2 = x + st.sway, cy2 = y0 + st.len * 0.55;
        var x22 = x + st.sway * 1.1 + st.tear, y22 = y0 + st.len;
        var w0 = st.w, w1 = st.w * st.taper;
        var d2 = 'M ' + (x - w0 / 2) + ' ' + y0 +
                 ' Q ' + (cx2 - w1 / 2) + ' ' + cy2 + ' ' + (x22 - w1 / 2) + ' ' + (y22 - 2) +
                 ' Q ' + x22 + ' ' + (y22 + 3) + ' ' + (x22 + w1 / 2) + ' ' + (y22 - 2) +
                 ' Q ' + (cx2 + w1 / 2) + ' ' + cy2 + ' ' + (x + w0 / 2) + ' ' + y0 + ' Z';
        solids += '<g><path d="' + d2 + '" fill="url(#rrb-c-' + st.ci + ')" opacity="' + st.opa + '"/>' +
                  '<path d="' + d2 + '" fill="none" stroke="rgba(0,0,0,0.08)" stroke-width="0.5"/></g>';
      }
      if (i % 2 === 0) {
        knots += '<ellipse cx="' + st.x + '" cy="' + (cordY + 1) + '" rx="' + (st.w * 0.55) + '" ry="3.5" fill="#8A3D2E" opacity="0.42"/>';
      }
    });

    previewSvg.style.opacity = '0';
    previewSvg.innerHTML = '<defs>' + defs + '</defs>' + bgRect + sheers + solids + knots;
    requestAnimationFrame(function () { previewSvg.style.opacity = '1'; });
  }

  // ---------- price + helper + add-to-cart ----------
  function renderPrice() {
    var total = calculateTotal();
    if (priceEl) priceEl.textContent = formatMoney(total);
    if (priceBreakdownEl) {
      var parts = [LENGTH_LABEL[state.length] + ' base · ' + formatMoney(BASE_PRICE[state.length])];
      if (!isStockedPalette(state.palette) && state.palette.length >= MIN_COLORS) {
        parts.push('Custom palette · ' + formatMoney(CUSTOM_PALETTE_UPCHARGE));
      }
      state.addons.forEach(function (a) {
        parts.push(ADDON_LABEL[a] + ' · ' + formatMoney(addonPrice(a)));
      });
      var matPrice = (MATERIAL_PRICE[state.material] || {})[state.length] || 0;
      if (matPrice > 0) {
        parts.push(MATERIAL_LABEL[state.material] + ' · ' + formatMoney(matPrice));
      }
      var spinePrice = (SPINE_PRICE[state.spine] || {})[state.length] || 0;
      if (spinePrice > 0) {
        parts.push(SPINE_LABEL[state.spine] + ' · ' + formatMoney(spinePrice));
      }
      priceBreakdownEl.textContent = parts.join('  ·  ');
    }
  }

  function renderHelper() {
    var enough = state.palette.length >= MIN_COLORS;
    if (addBtn) addBtn.disabled = !enough;
    if (helperEl) {
      helperEl.textContent = enough
        ? (state.length === '25ft' ? '✓ Ready when you are. 25′ strands are tied to order — about 2 weeks to ship, or add the rush make.' : '✓ Ready when you are. Estimated 5–7 days to ship.')
        : 'Pick at least ' + MIN_COLORS + ' colors to continue (' + state.palette.length + ' / ' + MIN_COLORS + ').';
      helperEl.classList.toggle('is-ready', enough);
    }
  }

  // ---------- preview SVG capture (for order line-item) ----------
  function capturePreviewSvg() {
    if (!previewSvg) return '';
    // outerHTML of the rendered SVG; Sarah sees this in the order admin / email template
    // (rendered inline since SVG is XML). Keep it under ~32KB for cart-property safety.
    var src = previewSvg.outerHTML || '';
    // strip newlines + collapse whitespace to keep it compact
    src = src.replace(/\s+/g, ' ').trim();
    if (src.length > 32000) src = src.slice(0, 32000) + '<!-- truncated -->';
    return src;
  }

  // ---------- AJAX add-to-cart ----------
  function paletteHumanName() {
    var names = state.palette.map(function (h) { return colorByHandle[h] ? colorByHandle[h].name : h; });
    if (names.length <= 2) return names.join(' + ');
    return names.slice(0, -1).join(', ') + ' + ' + names[names.length - 1];
  }
  function postAdd(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items }),
    }).then(function (r) { return r.json(); });
  }

  addBtn?.addEventListener('click', function () {
    if (state.palette.length < MIN_COLORS) return;
    var customStreamerVariantId = (cfg.variants && cfg.variants[state.length]);
    if (!customStreamerVariantId) {
      console.error('[rr-builder] missing variant id for length', state.length);
      return;
    }

    var balancePreset = (BALANCE_PRESETS.indexOf(state.balance) !== -1) ? state.balance : 'Equal';
    var balanceWeights = computeBalanceWeights(balancePreset, state.palette.length);
    var items = [{
      id: customStreamerVariantId,
      quantity: 1,
      properties: {
        '_palette': state.palette.join(','),
        'Palette': paletteHumanName(),
        '_palette_weights': balanceWeights.join(','),
        'Balance': balancePreset,
        '_arrangement': state.arrangement,
        'Arrangement': (ARRANGEMENT_LABEL[state.arrangement] && ARRANGEMENT_LABEL[state.arrangement].copy) || 'Woven mix',
        '_length': state.length,
        'Length': LENGTH_LABEL[state.length],
        '_addons': state.addons.join(','),
        'Add-ons': state.addons.length ? state.addons.map(function (a) { return ADDON_LABEL[a]; }).join(', ') : 'None',
        '_material': state.material,
        'Material': MATERIAL_LABEL[state.material] || 'Light-catching vinyl (included)',
        '_spine': state.spine,
        'Spine': SPINE_LABEL[state.spine] || 'White cotton twine (included)',
        '_occasion': state.occasion || '',
        '_preview_svg': capturePreviewSvg()
      }
    }];
    if (notesEl && notesEl.value.trim()) items[0].properties['Special requests'] = notesEl.value.trim();

    // Append addon products as separate cart lines (rush resolves to its
    // length-tiered SKU — rr-addon-rush-make-25ft for a 25 ft build).
    state.addons.forEach(function (a) {
      var vid = cfg.addons && cfg.addons[addonKeyForCart(a)];
      if (vid) items.push({ id: vid, quantity: 1, properties: { '_for_custom_streamer': '1' } });
    });

    // Custom palette upcharge as a separate line if applicable
    if (!isStockedPalette(state.palette)) {
      var upId = cfg.addons && cfg.addons['custom-palette-upcharge'];
      if (upId) items.push({ id: upId, quantity: 1, properties: { '_for_custom_streamer': '1' } });
    }

    // Premium material upgrade as a separate line if applicable
    if (state.material && state.material !== 'vinyl') {
      var matMap = (cfg.materials && cfg.materials[state.material]) || null;
      var matVid = matMap && matMap[state.length];
      if (matVid) items.push({ id: matVid, quantity: 1, properties: { '_for_custom_streamer': '1', 'Material upgrade': MATERIAL_LABEL[state.material] } });
    }

    // Premium spine upgrade as a separate line if applicable
    if (state.spine && state.spine !== 'cotton-twine') {
      var spineMap = (cfg.spines && cfg.spines[state.spine]) || null;
      var spineVid = spineMap && spineMap[state.length];
      if (spineVid) items.push({ id: spineVid, quantity: 1, properties: { '_for_custom_streamer': '1', 'Spine upgrade': SPINE_LABEL[state.spine] } });
    }

    addBtn.disabled = true;
    addBtn.querySelector('[data-rr-add-label]').textContent = 'Adding…';
    postAdd(items)
      .then(function (resp) {
        if (resp && resp.status && resp.status !== 200) {
          throw new Error(resp.description || 'Cart add failed');
        }
        document.dispatchEvent(new CustomEvent('rr:cart:added'));
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { itemCount: cart.item_count } }));
        addBtn.querySelector('[data-rr-add-label]').textContent = 'Added ✓';
        setTimeout(function () {
          addBtn.disabled = false;
          addBtn.querySelector('[data-rr-add-label]').textContent = 'Add to cart';
        }, 1400);
      })
      .catch(function (err) {
        console.error('[rr-builder] add to cart failed', err);
        addBtn.disabled = false;
        addBtn.querySelector('[data-rr-add-label]').textContent = 'Try again';
        if (helperEl) {
          helperEl.textContent = 'Couldn\'t add to cart — check your connection and try again.';
          helperEl.classList.remove('is-ready');
        }
      });
  });

  // ---------- util ----------
  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) { return ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' })[c]; });
  }

  // ---------- master render ----------
  function rerender() {
    renderSwatches();
    renderSelected();
    renderBalance();
    renderArrangement();
    renderLength();
    renderMaterial();
    renderSpine();
    renderAddons();
    renderPreview();
    renderPrice();
    renderHelper();
  }

  // initial paint
  rerender();
  hydrateMissingAddonIds();
})();
